/**
 * @class FrameworkTheme
 *
 * @description This component calls Theme_findOne api endpoint and sets on its theme property
 */
export default {
  data() {
    return {
      theme: {},
      themeOptions: null,
    }
  },
  methods: {
    async loadTheme(id = window.CORE.subSystem.id) {
      this.theme = this.$CORE.theme

      this.themeOptions = {
        schema: {
          title: 'Editor',
          type: 'object',
          properties: {
            style: {
              title: 'Style',
              type: 'string',
              enum: ['Default', 'Pink', 'Blue', 'Green', 'Orange', 'Red', 'fourig'],
              default: this.theme.style,
            },
          },
        },
      }
    },
  },
}
